







import { Component, Vue } from 'vue-property-decorator';

@Component({
    props: {
        print: Function,
    },
})
export default class TestComponent extends Vue {}
